import React from "react";
import Skeleton from "react-loading-skeleton";
import { useDesign } from "../../context/DesignContext";

/**
 * Content-block loader used by Highlight, Banner, My Store Full View, etc.
 * Public themed pages: design-token colors (same pattern as StayUpToDateSkeleton / DataSkeleton).
 * Default theme / analytics: neutral gray.
 */
export const BannerSkeleton = (props: any) => {
  const { designTokens, additionalClass, forceNeutral = false, isAnalyticsView = false } = props;
  const { templateName, primaryColor, tertiaryColor } = useDesign();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [isInLoadingPageAnalytics, setIsInLoadingPageAnalytics] =
    React.useState(false);

  React.useEffect(() => {
    if (containerRef.current) {
      const parentWithClass = containerRef.current.closest(
        ".loadingPageAnalytics",
      );
      setIsInLoadingPageAnalytics(!!parentWithClass);
    }
  }, []);

  const effectiveTemplateName = isAnalyticsView ? "default" : String(
    designTokens?.templateName || templateName || ""
  ).toLowerCase();
  const useNeutralLoader =
    forceNeutral ||
    isInLoadingPageAnalytics ||
    effectiveTemplateName === "default";

  // Surface (forth), not page bg (primary) — same as live cards / Website LiB.
  const fillColor = useNeutralLoader
    ? "#ededed"
    : designTokens?.forthColor ||
      designTokens?.primaryColor ||
      primaryColor ||
      "#ededed";
  const borderColor = useNeutralLoader
    ? "#e6e7eb"
    : designTokens?.tertiaryColor ||
      tertiaryColor ||
      designTokens?.secondaryColor ||
      "#e6e7eb";

  return (
    <div
      ref={containerRef}
      className={
        "banner-skeleton" + (additionalClass ? ` ${additionalClass}` : "")
      }
      style={{
        border: `1px solid ${borderColor}`,
        backgroundColor: useNeutralLoader ? "#fff" : fillColor,
      }}
      aria-hidden="true"
    >
      <Skeleton
        className="bannerSkeleton"
        baseColor={fillColor}
        highlightColor={fillColor}
        style={{
          borderRadius: 15,
          border: useNeutralLoader ? undefined : `1px solid ${borderColor}`,
        }}
      />
    </div>
  );
};
